
    import React from 'react';

// const ApiURl = "https://slgold.algo2bot.com/ajax";
// const ApiURl = "http://localhost/Project/ecommere_react_with_php_main/ecommere_react_with_php_main/ajax/";

 const ApiURl = "https://luxaddi.algo2bots.com/ajax/";
// const ApiURl = "https://localhost/ajax";





    export default   ApiURl ;
